<form [formGroup]="formGroup" class="mini-bestest">
  @for (element of elements; track element.name) {
    @if (element.type === "section" && !getPairQuestions(element).length) {
      <div class="section">
        <b class="section-title">{{ getQuestionTitle(element.title) }}</b>
        @if (getQuestionInstruction(element.title)) {
          <div class="mini-bestest-instruction">
            {{ getQuestionInstruction(element.title) }}
          </div>
        }
      </div>
    }
    @if (getPairQuestions(element).length) {
      <div class="mini-bestest-row">
        <div class="mini-bestest-q">
          <div class="mini-bestest-q-title">
            <span>{{ getQuestionTitle(element.title) }}</span>
          </div>
          @if (getQuestionInstruction(element.title)) {
            <div class="mini-bestest-instruction">
              {{ getQuestionInstruction(element.title) }}
            </div>
          }
        </div>

        <div class="mini-bestest-a">
          @for (question of getPairQuestions(element); track question.name) {
            <div class="mini-bestest-part">
              <div class="mini-bestest-part-title">
                {{ getQuestionTitle(question.title) }}
              </div>
              @if (getQuestionInstruction(question.title)) {
                <div class="mini-bestest-instruction">
                  {{ getQuestionInstruction(question.title) }}
                </div>
              }
              <ng-container
                [ngTemplateOutlet]="choices"
                [ngTemplateOutletContext]="{ $implicit: question }"
              ></ng-container>
            </div>
          }
        </div>
      </div>
    }
    @if (element.type === "radiogroup" && !isPairQuestion(element)) {
      <div class="mini-bestest-row">
        <div class="mini-bestest-q">
          <div class="mini-bestest-q-title">
            <span>{{ getQuestionTitle(element.title) }}</span>
          </div>
          @if (getQuestionInstruction(element.title)) {
            <div class="mini-bestest-instruction">
              {{ getQuestionInstruction(element.title) }}
            </div>
          }
        </div>

        <div class="mini-bestest-a">
          <ng-container
            [ngTemplateOutlet]="choices"
            [ngTemplateOutletContext]="{ $implicit: element }"
          ></ng-container>
        </div>
      </div>
    }
    @if (isScoreElement(element)) {
      <div
        class="mini-bestest-score"
        [class.mini-bestest-total]="isTotalScoreElement(element)"
      >
        <div class="mini-bestest-score-title">
          {{ getQuestionTitle(element.title) }}
        </div>
        <div class="mini-bestest-score-value">
          {{ getScoreDisplay(element.name) }} /
          {{ getMaxScore(element.name) }}
        </div>
      </div>
    }
  }

  <!-- Declared inside the form so formControlName finds the form group -->
  <ng-template #choices let-question>
    <div class="mini-bestest-group">
      @for (choice of question.choices; track choice.value) {
        <label class="mini-bestest-option">
          <input
            type="radio"
            [formControlName]="question.name"
            [value]="choice.value"
            (click)="onRadioClick(question.name, choice.value)"
          />
          <span class="mini-bestest-option-text">{{
            choice.text
          }}</span>
        </label>
      }
    </div>
  </ng-template>
</form>
